import {Route} from "@angular/router";
import {LoginComponent} from "./login/login.component";
import {RegisterComponent} from "./register/register.component";
import {AuthGuard} from "./shared/security/auth.guard";
import {ClubsComponent} from "./clubs/clubs.component";
import {UsersListComponent} from "./users-list/users-list.component";
import {UserAddComponent} from "./user-add/user-add.component";
import {FieldAddComponent} from "./field-add/field-add.component";
import {FieldsListComponent} from "./fields-list/fields-list.component";
import {LightingComponent} from "./lighting/lighting.component";
import {ClubAddComponent} from "./club-add/club-add.component";
import {HomeComponent} from "./home/home.component";
import {ResetPasswordComponent} from "./reset-password/reset-password.component";
import {SettingsComponent} from "./settings/settings.component";
import {LogoutComponent} from "./logout/logout.component";
import {UserInfoComponent} from "./user-info/user-info.component";
import {ErrorComponent} from "./error/error.component";
import {ReservationsComponent} from "./reservations/reservations.component";
import {AgendaComponent} from "./agenda/agenda.component";
import {AgendaService} from "./shared/model/agenda.service";
import {AgendaAddComponent} from "./agenda-add/agenda-add.component";

export const routerConfig: Route[] = [
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'lighting',
    component: LightingComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'clubs',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'add',
        component: ClubAddComponent
      },
      {
        path: '',
        component: ClubsComponent
      }
    ]
  },
  {
    path: 'fields',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'add',
        component: FieldAddComponent
      },
      {
        path: '',
        component: FieldsListComponent
      }
    ]
  },
  {
    path: 'users',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'add',
        component: UserAddComponent
      },
      {
        path: '',
        component: UsersListComponent
      }
    ]
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reservations',
    component: ReservationsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'errors',
    component: ErrorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'agenda',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'add',
        component: AgendaAddComponent
      },
      {
        path: '',
        component: AgendaComponent
      }
    ]
  },
  {
    'path': 'login',
    component: LoginComponent
  },
  {
    'path': 'logout',
    component: LogoutComponent
  },
  {
    path: 'register',
    component: RegisterComponent
  },
  {
    path: 'info',
    component: UserInfoComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'reset',
    component: ResetPasswordComponent
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];





